import React, { useContext } from 'react';
import MyContext from '../context/MyContext';
import { Link } from 'react-router-dom';
import { updateOrder } from '../helpers/apiCalls';
import { useForm } from 'react-hook-form';

const HistoryInvoice = ({ item }) => {
  const context = useContext(MyContext);
  const { history, setHistory } = context;

  const { register, handleSubmit} = useForm({
    defaultValues: { status: item.status },
  });

  const onSubmit = async (data) => {
    data.status = data.status === 'true' ? true : false;
    await updateOrder(data, item._id);
    const newHist = history.filter((invoice) => {
      if (invoice._id === item._id) {
        invoice.status = data.status;
      }
      return invoice;
    });

    setHistory(newHist);
  };

  return (
    <tr key={item._id}>
      <td>{item.paymentID}</td>
      <td>{new Date(item.createdAt).toLocaleDateString()}</td>
      <td>{item.fullName}</td>
      <td> {item.status.toString()} </td>
      <td>
        <Link to={`/orderdetails/${item._id}`}>View</Link>
      </td>
      <td>
        <form onSubmit={handleSubmit(onSubmit)}>
          <select {...register('status')}>
            <option value='true'>True</option>
            <option value='false'>False</option>
          </select>
          <input type='submit' />
        </form>
      </td>
    </tr>
  );
};

export default HistoryInvoice;
